import React from "react";
import { Card, List, Typography, Tag, Button } from "antd";
import { BookOutlined, RightOutlined } from "@ant-design/icons";

const { Title, Text, Paragraph } = Typography;

// 科普文章清單
const articles = [
    {
        id: "organ-transplant-cat",
        title: "移植後，我還能抱抱我的貓嗎？器官移植受者的「養貓安全指南」",
        summary: "破解移植後必須送養寵物的迷思，從免疫抑制原理出發，提供醫學證實的風險管理策略，讓情感支持與醫療安全並行。",
        date: "2026-05-01",
        tag: "移植照護",
        color: "teal",
        path: "/article/transplant-cat-risk-article.html"
    },
    {
        id: "yunnan-baiyao",
        title: "雲南白藥不是犬貓急救神藥：醫療觀念的斷層與真正該做的事",
        summary: "破除將『雲南白藥』視為急救神藥的迷思，揭露其在急性創傷中的證據空洞，強調回歸急診生理學穩定原則的重要性。",
        date: "2026-04-24",
        tag: "急診醫療",
        color: "red",
        path: "/article/yunnan-baiyao.html"
    },
    {
        id: "rabbit-nutrition",
        title: "致命的溺愛：兔子攝取肉類與澱粉的生理風險",
        summary: "解析兔子作為專職草食動物的消化機制，揭開肉類蛋白質與澱粉如何引發致命的盲腸菌叢失衡與腸毒血症。",
        date: "2026-04-20",
        tag: "兔子照護",
        color: "green",
        path: "/article/rabbit-nutrition-risks.html"
    },
    {
        id: "oil",
        title: "別讓化毛膏變成催命符：礦物油引發的「靜默」肺炎",
        summary: "很多飼主常用石蠟油或化毛膏幫貓咪通便，但貓咪吸入油脂時不會咳嗽，導致肺部在無聲無息中受損，且不可逆轉。",
        date: "2026-04-15",
        tag: "貓咪照護",
        color: "orange",
        path: "/article/oil.html"
    },
    {
        id: "o2",
        title: "致命的氣體：當拯救生命的氧氣成為毒藥",
        summary: "深入了解醫療氧氣與工業氣體的致命差異，以及診所內部在物料管理上的重大系統性漏洞。",
        date: "2026-04-10",
        tag: "醫療安全",
        color: "red",
        path: "/article/o2.html"
    },
];

const Medical = () => {
    return (
        <div style={{ padding: 20, maxWidth: 1000, margin: "0 auto", minHeight: "100vh" }}>
            <div style={{ marginBottom: 30, textAlign: "left" }}>
                <Title level={2} style={{ color: "#1677ff" }}>
                    <BookOutlined style={{ marginRight: 10 }} />
                    醫療與科普教育
                </Title>
                <Text type="secondary">
                    提供正確的動物醫療知識，幫助飼主建立專業認知，守護毛孩健康。
                </Text>
            </div>

            <List
                grid={{ gutter: 20, xs: 1, sm: 1, md: 2, lg: 2, xl: 2, xxl: 2 }}
                dataSource={articles}
                renderItem={(item) => (
                    <List.Item>
                        <Card
                            hoverable
                            style={{ borderRadius: 12, height: "100%", display: "flex", flexDirection: "column" }}
                            bodyStyle={{ flexGrow: 1, display: "flex", flexDirection: "column" }}
                        >
                            <div style={{ marginBottom: 12 }}>
                                <Tag color={item.color}>{item.tag}</Tag>
                                <Text type="secondary" style={{ float: "right" }}>{item.date}</Text>
                            </div>

                            <Title level={4} style={{ marginTop: 0 }}>{item.title}</Title>

                            <Paragraph ellipsis={{ rows: 2 }} type="secondary" style={{ flexGrow: 1 }}>
                                {item.summary}
                            </Paragraph>

                            <Button
                                type="link"
                                icon={<RightOutlined />}
                                style={{ padding: 0, marginTop: "auto" }}
                                onClick={() => window.open(item.path, "_blank")}
                            >
                                閱讀全文
                            </Button>
                        </Card>
                    </List.Item>
                )}
            />
        </div>
    );
};

export default Medical;